import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import CategoryGrid from '@/components/feature/CategoryGrid';
import FeatureGrid from '@/components/feature/FeatureGrid';
import CTASection from '@/components/feature/CTASection';
import ArticlePreview from '@/components/feature/ArticlePreview';
import SEOArticlesGrid from '@/components/feature/SEOArticlesGrid';
import Testimonials from '@/components/feature/Testimonials';
import Footer from '@/components/feature/Footer';
import { SITE_URL, SITE_NAME, SITE_LOGO, SITE_DESCRIPTION, SITE_DESCRIPTION_LONG } from '@/constants/seo';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: SITE_LOGO,
      description: SITE_DESCRIPTION_LONG,
    },
    {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
      description: SITE_DESCRIPTION,
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          'urlTemplate': `${SITE_URL}/?search={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <FeatureGrid />
      <CTASection />
      <ArticlePreview />
      <SEOArticlesGrid />
      <Testimonials />
      <Footer />
    </main>
  );
}